export function plainPostText(text: string): string {
  // Replace backend mentions: @[Name](user:ID) -> @Name
  let result = text.replace(/@\[(.*?)\]\(user:.*?\)/g, "@$1");
  // Replace backend tags: #[Tag](tag:ID) -> #Tag
  result = result.replace(/#\[(.*?)\]\(tag:.*?\)/g, "#$1");
  // Remove markdown links: [text](url) -> text
  result = result.replace(/\[(.*?)\]\((.*?)\)/g, "$1");
  // Collapse whitespace
  result = result.replace(/\s+/g, " ").trim();
  return result;
}
